import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Layout from 'antd/lib/layout'
import classNames from 'classnames'
import { RootState } from '@app-store/store'
import XArrowIcon from '@UI/XArrowIcon'
import SiderMenu from './Menu'
import { rootActions } from '@app-store/slices'
import styles from './index.scss'

function SideNavigation({ showUserGuide, showVideoGuide }) {
    const { isSiderOpen } = useSelector((state: RootState) => state.ui.common)
    const dispatch = useDispatch()
    const onCollapsed = () => dispatch(rootActions.ui.common.toggleSider())

    return (
        <Layout.Sider
            collapsible
            collapsed={!isSiderOpen}
            width={258}
            onCollapse={onCollapsed}
            className={classNames(styles['desktop-sider'])}
            theme="light"
            reverseArrow
            trigger={<XArrowIcon reverse={!isSiderOpen} />}
        >
            <SiderMenu
                collapsed={!isSiderOpen}
                onCollapsed={onCollapsed}
                showUserGuide={showUserGuide}
                showVideoGuide={showVideoGuide}
            />
        </Layout.Sider>
    )
}
export default SideNavigation
